import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  GET_USER_DASHBOARD,
  GET_USER_DETAILS_FOR_PROGRESS_BAR,
  POST_DISMISS_PROGRESS_BAR
} from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import { BIBlue, BILightGrey } from "../../assets/helpers";
import { Box, Button, Card, IconButton, LinearProgress, Stack, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useNavigate } from "react-router-dom";
import PromptModal from "../common/PromptModal";
import { Postrequestcall } from "../../request/Postrequest";
import { English } from "../../constant/EnglishFallback";

function ProgressBar(props) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const token = loginData?.accessToken;

  const nav = useNavigate();
  const [isPrograssBar, setIsPrograssBar] = useState(true);
  const [progressStatus, setProgressStatus] = useState(0);
  const [progressLoading, setProgressLoading] = useState(true);
  const [tasksCompleteStatus, setTasksCompleteStatus] = useState(false);
  const [isProgressBarExpanded, setIsProgressBarExpanded] = useState(false);
  const [showProgressBarDismissModal, setShowProgressBarDismissModal] = useState(false);
  const [progressBardDetails, setProgressBarDetails] = useState({
    userTrade1: false,
    userFollowingProject: false,
    userEducation: false,
    userExperience: false,
    userExperience1: false,
    userBuilderBucks: false
  });

  const {
    PROGRESS_HEADING = English?.Home?.PROGRESS_HEADING,
    PROGRESS_SUBHEADING_1 = English?.Home?.PROGRESS_SUBHEADING_1,
    PROGRESS_SUBHEADING_2 = English?.Home?.PROGRESS_SUBHEADING_2,
    PROGRESS_SUBHEADING_3 = English?.Home?.PROGRESS_SUBHEADING_3,
    PROGRESS_SUBHEADING_4 = English?.Home?.PROGRESS_SUBHEADING_4,
    PROGRESS_SUBHEADING_5 = English?.Home?.PROGRESS_SUBHEADING_5,
    PROGRESS_BUTTON_DISMISS = English?.Home?.PROGRESS_BUTTON_DISMISS,
    TEXT_GO_TO_PROFILE = English?.Home?.TEXT_GO_TO_PROFILE,
    PROGRESS_ALERT_TITLE = English?.Home?.PROGRESS_ALERT_TITLE,
    TEXT_DELETE = English?.Home?.TEXT_DELETE
  } = multiLanguageData?.Home || {};

  useEffect(() => {
    if (userId && token) {
      getUserDetails();
    }
  }, [userId, token]);

  const dismissProgressBar = async () => {
    try {
      const obj = {
        Id: userId
      };
      await Postrequestcall(POST_DISMISS_PROGRESS_BAR, obj, token);
      setIsPrograssBar(true);
      setTasksCompleteStatus(false);
      setProgressLoading(true);
      setShowProgressBarDismissModal(false);
      // props?.fetchDashboardData(); --> Optimization Remaining just update the dashboard response redux after dismiss progressbar
    } catch (error) {
      console.log("dismissProgressBar-> Error While Dismissing The Progress Bar: ", error);
    }
  };

  const getUserDetails = async () => {
    try {
      let progressBarInfo;
      if (props?.from == "new-dashboard") {
        progressBarInfo = props?.dashboardData;
        setIsPrograssBar(props?.dashboardData?.isProgressBarDismiss);
      } else {
        const res2 = await Getrequestcall(`${GET_USER_DASHBOARD}/${userId}`, token);

        const userDashboardData = res2?.data?.data;
        setIsPrograssBar(userDashboardData.isProgressBarDismiss);

        const userResponse = await Getrequestcall(
          `${GET_USER_DETAILS_FOR_PROGRESS_BAR}/${userId}`,
          token
        );
        progressBarInfo = userResponse?.data?.data[0];
      }
      if (
        progressBarInfo?.userTrade &&
        progressBarInfo?.followingProject &&
        progressBarInfo?.education &&
        (progressBarInfo?.experience || progressBarInfo?.experience1) &&
        progressBarInfo?.builderbuck
      ) {
        setTasksCompleteStatus(true);
      } else {
        setTasksCompleteStatus(false);
      }
      const completedTasks = [
        progressBarInfo?.userTrade,
        progressBarInfo?.followingProject,
        progressBarInfo?.education,
        progressBarInfo?.experience || progressBarInfo?.experience1,
        progressBarInfo?.builderbuck
      ].filter(Boolean).length;

      setProgressStatus((completedTasks / 5) * 100);
      setProgressBarDetails({
        userTrade1: progressBarInfo?.userTrade,
        userFollowingProject: progressBarInfo?.followingProject,
        userEducation: progressBarInfo?.education,
        userExperience: progressBarInfo?.experience,
        userExperience1: progressBarInfo?.experience1,
        userBuilderBucks: progressBarInfo?.builderbuck
      });
      setProgressLoading(false);
    } catch (e) {
      console.log("getUserDetails-> Error while getting Progress Bar Details: ", e);
    }
  };

  return (
    <>
      {!progressLoading && !isPrograssBar && !tasksCompleteStatus && (
        <Box className={props?.from == "new-dashboard" ? "" : "pagelist-content"} sx={{ p: 2 }}>
          <LinearProgress
            variant="determinate"
            value={progressStatus}
            sx={{
              backgroundColor: BILightGrey,
              borderRadius: "10px",
              height: "5px",
              ".MuiLinearProgress-bar": {
                backgroundColor: BIBlue
              }
            }}
          />
          <div style={{ marginTop: "10px" }}>
            <Typography variant="body1">{PROGRESS_HEADING}</Typography>
          </div>
          <div>
            <ul style={{ margin: 2 }}>
              {!progressBardDetails?.userTrade1 && (
                <li>
                  {" "}
                  <Typography variant="body1">{PROGRESS_SUBHEADING_1} </Typography>
                </li>
              )}

              {isProgressBarExpanded && (
                <>
                  {!progressBardDetails?.userFollowingSite && (
                    <li>
                      <Typography variant="body1">{PROGRESS_SUBHEADING_2} </Typography>
                    </li>
                  )}
                  {!progressBardDetails?.userEducation && (
                    <li>
                      <Typography variant="body1">{PROGRESS_SUBHEADING_3} </Typography>
                    </li>
                  )}
                  {progressBardDetails?.userExperience ||
                  progressBardDetails?.userExperience1 ? null : (
                    <li>
                      <Typography variant="body1">{PROGRESS_SUBHEADING_4}</Typography>
                    </li>
                  )}
                  {!progressBardDetails?.userBuilderBucks && (
                    <li>
                      <Typography variant="body1">{PROGRESS_SUBHEADING_5}</Typography>
                    </li>
                  )}
                </>
              )}
            </ul>
          </div>
          <Stack alignItems={"center"} direction="row" justifyContent="space-between">
            <Typography>
              <IconButton
                onClick={() => {
                  setIsProgressBarExpanded(!isProgressBarExpanded);
                }}>
                {isProgressBarExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </Typography>
            <Stack direction={"row"} gap={2}>
              <Typography>
                <Button
                  color="primary"
                  size="small"
                  onClick={() => {
                    setShowProgressBarDismissModal(true);
                  }}>
                  {PROGRESS_BUTTON_DISMISS}
                </Button>
              </Typography>
              <Typography>
                <Button
                  color="primary"
                  size="small"
                  variant="contained"
                  sx={{
                    backgroundColor: BIBlue
                  }}
                  onClick={() => {
                    nav(`/${userId}`);
                  }}>
                  {TEXT_GO_TO_PROFILE}
                </Button>
              </Typography>
            </Stack>
          </Stack>
        </Box>
      )}

      {showProgressBarDismissModal && (
        <PromptModal
          isOpen={showProgressBarDismissModal}
          onClose={() => setShowProgressBarDismissModal(false)}
          title={PROGRESS_ALERT_TITLE}
          redButtonText={TEXT_DELETE}
          onRedButtonClick={() => {
            dismissProgressBar();
          }}
        />
      )}
    </>
  );
}

export default ProgressBar;
